import {LangKeyType} from '../../../../../../../provider/locale/translation/type';
import {AddressCommentTemplateStateType} from '../../../../../../../service/company-v2/types/company-address-type';
import {FormRuleType} from '../../../../../../../service/form/form-rules-hook-type';

import {AddressCommentTemplateType} from './address-comment-templates-type';

type GetLocalizedStringType = (stringKey: LangKeyType) => string;

export function getAddressCommentTemplateState(
    template: AddressCommentTemplateType | null,
    fieldValueMap: Record<string, string>
): AddressCommentTemplateStateType | null {
    if (!template) {
        return null;
    }

    return {
        fieldCount: template.fieldList.length,
        filledCount: template.fieldList.filter((field) => fieldValueMap[field.name]?.trim()).length,
    };
}

/**
 * Blocks saving a template nobody filled in. A template without fields is a complete sentence on
 * its own, and the plain comment field stays optional as it was before templates existed.
 */
export function getAddressCommentTemplateRule(
    getTemplateState: () => AddressCommentTemplateStateType | null,
    getLocalizedString: GetLocalizedStringType
): FormRuleType<string | null> {
    return {
        validator: () => {
            const templateState = getTemplateState();

            if (!templateState || templateState.fieldCount === 0 || templateState.filledCount > 0) {
                return Promise.resolve();
            }

            return Promise.reject(
                new Error(
                    getLocalizedString(
                        templateState.fieldCount === 1
                            ? 'VALIDATION__ERROR__FIELD_IS_REQUIRED'
                            : 'COMPANY_FORM__ADDRESS__COMMENT__TEMPLATES__ERROR__AT_LEAST_ONE_FIELD'
                    )
                )
            );
        },
    };
}
